<div class="card">
  <div class="card-content outing-report-page">

    <!-- Stat cards — same shared classes as the Availability Report -->
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalOutingsInYear }}</span>
          <span class="stats-card-label">Outings</span>
          <span class="stats-card-sublabel">{{ totalDoneInYear }} completed in {{ selectedYear }}</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-calendar"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ employeeRowCount }}</span>
          <span class="stats-card-label">Employees</span>
          <span class="stats-card-sublabel">{{ countMode === 'invited' ? 'Invited at least once' : 'Participated at least once' }}</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-users"></i></div>
      </div>
      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ overallParticipationRate | number:'1.0-1' }}%</span>
          <span class="stats-card-label">Participation rate</span>
          <span class="stats-card-sublabel">Participated of invited</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-chart-line"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ busiestMonthLabel }}</span>
          <span class="stats-card-label">Busiest month</span>
          <span class="stats-card-sublabel">Most outings held</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-star"></i></div>
      </div>
    </div>

    <!-- Filters (toggled by the header funnel; employee search lives in the main header) -->
    <div class="filter-bar filter-bar-collapsible mb-4"
         [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label class="filter-label">Year</label>
          <p-select [options]="yearOptions" [(ngModel)]="selectedYear" (onChange)="onFilterChange()"
                    optionLabel="label" optionValue="value" panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
        </div>
        <div class="filter-field">
          <label class="filter-label">Project</label>
          <p-select [options]="projectFilterOptions" [(ngModel)]="filterProjectId" (onChange)="onFilterChange()"
                    optionLabel="label" optionValue="value" [filter]="true" [showClear]="true"
                    panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
        </div>
        <div class="filter-field">
          <label class="filter-label">Service Group</label>
          <p-select [options]="serviceGroupOptions" [(ngModel)]="filterServiceGroupId"
                    optionLabel="label" optionValue="value" [filter]="true" [showClear]="true"
                    panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
        </div>
        <div class="filter-field">
          <label class="filter-label">Count</label>
          <p-select [options]="countModeOptions" [(ngModel)]="countMode"
                    optionLabel="label" optionValue="value"
                    panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
        </div>
      </div>
      <div class="filter-bar-actions">
        <button type="button" *ngIf="hasActiveFilters()" class="btn-clear-filters"
                (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <!-- 12-month grid: one row per employee, one column per month -->
    <div class="report-table-container">
      <p-table
        [scrollable]="true"
        scrollHeight="flex"
        [value]="reportRows"
        [loading]="loading"
        [tableStyle]="{ 'min-width': '100%' }"
        styleClass="p-datatable no-column-lines compact-striped-table outing-report-table fill-height">

        <ng-template pTemplate="header">
          <tr>
            <th rowspan="2" class="employee-header">Employee</th>
            <th colspan="12" class="title-header">
              {{ countMode === 'invited' ? 'Events invited to' : 'Events participated in' }} — {{ selectedYear }}
            </th>
            <th rowspan="2" class="total-header">Total</th>
          </tr>
          <tr>
            <th *ngFor="let m of monthSummaries" class="month-header"
                [class.month-header--empty]="!m.outingCount"
                [pTooltip]="monthHeaderTooltip(m)" tooltipPosition="top">
              {{ m.label }}
              <span class="month-header-count" *ngIf="m.outingCount">{{ m.outingCount }}</span>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr [class.total-row]="row.rowType === 'total'">
            <td class="employee-cell">
              <ng-container *ngIf="row.rowType === 'total'">
                <strong>{{ row.employeeName }}</strong>
              </ng-container>
              <ng-container *ngIf="row.rowType !== 'total'">
                <span class="employee-cell-name">{{ row.employeeName }}</span>
                <span class="employee-cell-meta">{{ row.serviceGroupName || '—' }}</span>
              </ng-container>
            </td>
            <td *ngFor="let m of months" class="value-cell"
                [class.highlight-cell]="cellValue(row, m) > 0"
                [pTooltip]="cellTooltip(row, m)" tooltipPosition="top">
              {{ formatValue(cellValue(row, m)) }}
            </td>
            <td class="value-cell total-cell">{{ formatValue(row.yearTotal) }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr class="table-empty-row">
            <td [attr.colspan]="14" class="table-empty-cell">
              <div class="empty-state">
                <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                <p class="empty-message">No outing participation found</p>
                <p class="empty-description">
                  No completed outings match these filters for {{ selectedYear }}. Attendance is recorded
                  when a PM marks an outing done on the Manage Outings page.
                </p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
